<a class="link" [attr.href]="source" [attr.download]="fileName" target="_blank">{{ fileName }}</a>
